import { action, observable } from 'mobx';
import { api, schApi } from '../config';

// Helpers
import { getPath } from '../helpers/helpers';

// Components
import SessionStore from './SessionStore';
import moment from "moment";

let obx = observable({
  view: 'list',
  events: [],
  eventsNext: null,
  /**
   * Get sessions for proctor and store them in events array
   */
  getSessions: action(function getSessions(limit, status, callback, sessionSid, eatUnauthorized = false) {
    SessionStore.startLoading('Loading…', 'GetSessions');

    let statusArray = false;

    if(Array.isArray(status)) {
      statusArray = true;
    }

    obx.events = [];

    let query = '';

    if(limit) {
      query = `?limit=${limit}`;

      if(status && !statusArray) {
        query += `&status=${status}`;
      } else if(status && statusArray) {
        status.forEach(s => {
          query += `&status=${s}`;
        });
      }
    } else {
      if(status && !statusArray) {
        query = `?status=${status}`;
      } else if(status && statusArray) {
        status.forEach(s => {
          query += `&status=${s}`;
        });
      }
    }

    if(sessionSid && !limit && !status) {
      query = `?sessionSids=${sessionSid}`
    } else if(sessionSid && (limit || status)) {
      query += `&sesssionSids=${sessionSid}`
    }

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/sessions${query}`)
      .then(response => {
        obx.events = response.data.results;

        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          if(obx.eventsNext !== nextUrl) {
            obx.eventsNext = nextUrl;
          }
        } else {
          obx.eventsNext = null;
        }

        SessionStore.finishLoading('GetSessions');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        if (eatUnauthorized && error.response.status === 401) {
          //TODO: Delete this and conditionally make this call in componentWillMount of dashboard.js when we update iam client
          return;
        }
        SessionStore.throwError(error);
      })
  }),
  // Get an individual session
  sessionType: 'upcoming',
  session: {},
  getSingleSession: action(function(sid){
    let sessionMatch = false;
    obx.session = {};

    SessionStore.startLoading('Loading…', 'GetSession');

    obx.events.forEach(function(session){
      if(session.sid === sid) {
        obx.session = session;
        sessionMatch = true;
      }
    });


    if(!sessionMatch) {
      api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/singleSession?sessionSid=${sid}`)
        .then(response => {
          obx.session = response.data;
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
    }

    SessionStore.finishLoading('GetSession');
  }),
  // Get written exam file
  getExamFile: action(function(installSid, configurationSid, sessionSid, fileName) {
    SessionStore.startLoading('Loading…', 'getExamFile');

    api.get(`/installs/${installSid}/examConfigurations/${configurationSid}/examFile?sessionSid=${sessionSid}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        const tempLink = document.createElement('a');
        const file = new Blob([response.data], {type: 'application/pdf'});

        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, fileName);
        } else {
          const fileUrl = URL.createObjectURL(file);

          tempLink.href = fileUrl;
          tempLink.download = fileName;
          tempLink.click();

          window.URL.revokeObjectURL(fileUrl);
        }

        SessionStore.finishLoading('getExamFile');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Close a session
  closeSession: action(function(installSid, examSid, sessionSid, callback) {
    // SessionStore.startLoading('Loading…', 'CloseSession');

    const data = {
      type: 'messaging',
      reason: 'exam-completed'
    }

    api.post(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/close`, data)
      .then(response => {
        SessionStore.finishLoading('CloseSession');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get pending sessions
  pendingSessions: [],
  pendingNext: null,
  getPendingSessions: action(function(status, sortKey){
    SessionStore.startBackgroundLoading('GetPendingSessions');

    obx.pendingSessions = [];

    let sort = '';

    if(sortKey) {
      sort = `&sortKeys=${sortKey}`
    }

    api.get(`proctors/${SessionStore.userData.proctorAccountSid}/sessions/pending?status=${status}&limit=25${sort}`)
      .then(response => {
        obx.pendingSessions = response.data.results;

        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.pendingNext = nextUrl;
        } else {
          obx.pendingNext = null;
        }

        SessionStore.finishBackgroundLoading('GetPendingSessions');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get scheduling account
  scheduleAccountEnabled: false,
  getScheduleAccount: action(function(callback){
    SessionStore.startLoading('Loading…', 'getScheduleAccount');

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}`)
      .then(response => {
        obx.scheduleAccountEnabled = true;
        SessionStore.finishLoading('getScheduleAccount');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        obx.scheduleAccountEnabled = false;
        SessionStore.finishLoading('getScheduleAccount');
      })
  }),
  // Enable scheduling account
  createScheduleAccount: action(function(data, callback){
    SessionStore.startLoading('Loading…', 'createScheduleAccount');

    schApi.post(`accounts`, data)
      .then(response => {
        SessionStore.finishLoading('createScheduleAccount');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get schedule locations
  scheduleLocations: [],
  getScheduleLocations: action(function(){
    SessionStore.startLoading('Loading…', 'getScheduleLocations');

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/locations`)
      .then(response => {
        obx.scheduleLocations = response.data.results;
        SessionStore.finishLoading('getScheduleLocations');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Set schedule location
  scheduleLocation: null,
  setScheduleLocation: action(function(scheduleLocationSid){
    obx.scheduleLocations.forEach(scheduleLocation => {
      if(scheduleLocation.sid === scheduleLocationSid) {
        obx.scheduleLocation = scheduleLocation
      }
    });
  }),
  // Enable schedule for location
  enableLocationSchedule: action(function(data, callback){
    SessionStore.startLoading('Loading…', 'enableLocationSchedule');

    schApi.post(`accounts/${SessionStore.userData.proctorAccountSid}/locations`, data)
      .then(response => {
        SessionStore.finishLoading('enableLocationSchedule');

        if(callback) {
          callback(response.data);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get all location calendars
  locationCalendars: [],
  getLocationCalendars: action(function(locationSid, noErrorOnAvailability = false){
    SessionStore.startLoading('Loading…', 'getLocationCalendars');

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/calendars`)
      .then(response => {
        obx.locationCalendars = response.data.results;
        SessionStore.finishLoading('getLocationCalendars');
      })
      .catch(error => {
        if (noErrorOnAvailability && error.response.data.code === '1205') {
            console.log('No proctor location availability for this location...');
            SessionStore.finishLoading('getLocationCalendars');
        } else {
            SessionStore.throwError(error);
        }
      })
  }),
  // Get single location calendar
  locationCalendar: null,
  getCalendar: action(function(locationSid, calendarSid, callback){
    //SessionStore.startLoading('Loading…', 'getCalendar');

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/calendars/${calendarSid}`)
      .then(response => {
        obx.locationCalendar = response.data;
        //SessionStore.finishLoading('getCalendar');

        if(callback) {
          callback(response.data);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  timelineEvents: null,
  getTimelineEvents: action(async function(start, end){
    const assignColorToEvent = (event) => {
      const status = (event.extendedProps && event.extendedProps.session && event.extendedProps.session.status) ? event.extendedProps.session.status.toLowerCase() : '';
      let color;
      
      switch(status) {
        case 'scheduled':
          color = '#224590';
          break;
        case 'in progress':
          color = 'rgba(141, 71, 232, 1)';
          break;
        case 'closed':
          color = '#0f5e29ff';
          break;
        case 'cancelled':
          color = 'black';
          break;
        case 'onboarding':
          color = '#00df4aff';
          break;
        case 'checked in':
          color = '#00df4aff';
          break;
        case 'pending reconnect':
          color = '#815930ff';
          break;
        default:
          color = '#224590';
      }
      
      return { ...event, color };
    };

    if(start && end){
      const response = await schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/reports/timeline/events?startDateTime=${start}&endDateTime=${end}`)
      const eventsWithColor = response.data.events.map(assignColorToEvent);
      obx.timelineEvents = { ...response.data, events: eventsWithColor };

      return response;
    }
    
    const response = await schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/reports/timeline/events?startDateTime=${moment().startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')}&endDateTime=${moment().endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')}`)
    const eventsWithColor = response.data.events.map(assignColorToEvent);
    obx.timelineEvents = { ...response.data, events: eventsWithColor };
    return response;

  }),
  timelineResources: null,
  getTimelineResources: action(async function(){
    const response = await schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/reports/timeline/resources`)
    obx.timelineResources = response.data.results
    return response;
  }),
  // Create calendar
  calendar: null,
  createCalendar: action(function(locationSid, data, callback){
    SessionStore.startLoading('Loading…', 'createCalendar');

    schApi.post(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/calendars`, data)
      .then(response => {
        obx.calendar = response.data;
        SessionStore.finishLoading('createCalendar');

        if(callback) {
          callback(response.data);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Update calendar
  updateCalendar: action(function(locationSid, calendarSid, data, callback){
    SessionStore.startLoading('Loading…', 'updateCalendar');

    schApi.put(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/calendars/${calendarSid}`, data)
      .then(response => {
        obx.calendar = response.data;
        SessionStore.finishLoading('updateCalendar');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),

  deleteCalendar: action(function(locationSid, calendarSid) {
    SessionStore.startLoading('Loading...', 'deleteCalendar');

    schApi.delete(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${locationSid}/calendars/${calendarSid}`)
      .then(() => {
        obx.getLocationCalendars(locationSid);
        SessionStore.finishLoading('deleteCalendar');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get availability (calendar)
  availabilities: [],
  getAvailability: action(function(calendarSid, startDate, endDate, callback, skipStore){

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/calendars/${calendarSid}/availability?startDate=${startDate}&endDate=${endDate}`)
      .then(response => {

        if(!skipStore) {
          obx.availabilities = response.data.results;
        }

        if(callback) {
          callback(response.data.results);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get availability (schedule)
  getScheduleAvailability: action(function(scheduleSid, callback){

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/schedules/${scheduleSid}/availability`)
      .then(response => {
        console.log(response)

        // Remove any overrides, since we
        // just want the default availabilities
        for(let i = 0; i < response.data.results.length; i++) {
          if(response.data.results[i].override) {
            response.data.results.splice(i, 1);
          }
        }

        obx.availabilities = response.data.results;

        if(callback) {
          callback(response.data.results);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update availability
  updateAvailability: action(function(scheduleSid, data, callback){
    SessionStore.startLoading('Loading…', 'updateAvailability');

    data.update.forEach(availability => {
      if(availability.hasOwnProperty('override')) {
        delete availability.override;
      }
    })

    schApi.post(`accounts/${SessionStore.userData.proctorAccountSid}/schedules/${scheduleSid}/availability`, data)
      .then(response => {
        SessionStore.finishLoading('updateAvailability');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get exclusions
  exclusions: [],
  getExclusions: action(function(scheduleSid, callback){
    SessionStore.startLoading('Loading…', 'getAvailability');

    schApi.get(`accounts/${SessionStore.userData.proctorAccountSid}/exclusions?scheduleSid=${scheduleSid}`)
      .then(response => {
        SessionStore.finishLoading('getAvailability');

        obx.exclusions = response.data.results;

        if(callback) {
          callback(response.data.results);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  locationSeats: [],
  listSeats: action(function(accountSid, locationSid, appointmentSid, sortKeys = null) {
    let url = `accounts/${accountSid}/locations/${locationSid}/seats`

    if (appointmentSid) {
        url = `${url}?availableForAppointmentSid=${appointmentSid}`;
        if (sortKeys) {
            url = `${url}&sortKeys=${sortKeys}`;
        }
    } else if (!appointmentSid && sortKeys) {
        url = `${url}?sortKeys=${sortKeys}`
    }

    schApi.get(url)
      .then(response => {
        obx.locationSeats = response.data.results;
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  updateSeat: action(function(payload, seatSid, callback) {
    SessionStore.startLoading('Loading...', 'updateSeat');

    schApi.put(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${obx.scheduleLocation.sid}/seats/${seatSid}`, payload)
      .then(() => {
        SessionStore.finishLoading('listSeats');

        if (callback) callback();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  addSeat: action(function(payload, callback) {
    SessionStore.startLoading('Loading...', 'addSeat');

    schApi.post(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${obx.scheduleLocation.sid}/seats`, payload)
      .then(() => {
        setTimeout(() => {
          obx.listSeats(SessionStore.userData.proctorAccountSid, obx.scheduleLocation.sid)
          SessionStore.finishLoading('addSeat');
        }, 500);

        if (callback) callback();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  deleteSeat: action(function(seatSid) {
    SessionStore.startLoading('Loading...', 'deleteSeat');

    schApi.delete(`accounts/${SessionStore.userData.proctorAccountSid}/locations/${obx.scheduleLocation.sid}/seats/${seatSid}`)
      .then(() => {
        // Wait a little before updating seats so we pull accurate data
        setTimeout(() => {
          obx.listSeats(SessionStore.userData.proctorAccountSid, obx.scheduleLocation.sid)
          SessionStore.finishLoading('deleteSeat');
        }, 500)

      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  changeSeat: action(function(seatSid, appointmentSid, callback) {
    SessionStore.startLoading('changeSeat');
    if (!seatSid.includes('SE')) {
      seatSid = null;
    }

    schApi.patch(`accounts/${SessionStore.userData.proctorAccountSid}/appointments/${appointmentSid}`, {seatSid})
      .then(() => {
        // Wait a little before updating seats so we pull accurate data
        if (callback) {
            callback(seatSid);
        }
        SessionStore.finishLoading('changeSeat');
      })
      .catch((error) => {
        SessionStore.throwError(error);
        SessionStore.finishLoading('changeSeat');
      })
  }),

  changeSessionStatus: action(function(installSid, examSid, sessionSid, status) {
    SessionStore.startLoading('changeSessionStatus')
    api.patch(`installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`, {status: status})
    .then(() => {
      obx.session.status = status;
      SessionStore.finishLoading('changeSessionStatus');
    })
    .catch((error) => {
      SessionStore.throwError(error);
      SessionStore.finishLoading('changeSessionStatus');
    })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ScheduleStore.js